import { Button } from "@blueprintjs/core";
import styled from "@emotion/styled";
import { Link } from "react-router";

import { Box } from "@/components/layout/flexbox";
import { CTA_COLOR } from "@/css/constants";
import { ResourcePermissionsQuery } from "@/graphql";
import { NonNullableArrayItem } from "@/utils/types";

type ResourcePermission = NonNullableArrayItem<
  NonNullable<ResourcePermissionsQuery["resourcePermissions"]>
>;
type ResourcePermissionProgram = NonNullable<ResourcePermission["program"]>;

const titleCss = {
  fontSize: "14px",
  fontWeight: 500,
  color: "black",
};

interface ScenarioProgramProps {
  program: ResourcePermissionProgram;
}

export function ScenarioProgram({ program }: ScenarioProgramProps) {
  return (
    <Link
      to={`/programs/${program.id}`}
      style={{ marginBottom: 8, display: "block" }}
    >
      <StyledButton>
        <Box css={titleCss}>
          {program.name} {program.workspace && `(${program.workspace.name})`}
        </Box>
      </StyledButton>
    </Link>
  );
}

const StyledButton = styled(Button)`
  width: 100%;
  display: flex;
  justify-content: flex-start !important;
  height: 38px;
  border: 1px solid #e2e2e2 !important;
  box-shadow: none !important;
  padding: 7px 16px !important;

  &:hover,
  &:focus,
  &:active {
    cursor: pointer;
    border-color: ${CTA_COLOR} !important;
  }
`;
